












































































/* 
  getEmployInfo 获取聘用信息分页列表
  downloadContract 打印聘书
*/
import { Vue, Component } from "vue-property-decorator";
import {
  getEmployInfo,
  downloadContract,
  downloadCertificate
} from "../../../api/teacherRole";
import { download } from "../../../utils/common";

@Component({
  name: "employInfo"
})
export default class extends Vue {
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = [{ propXXX: "XXX" }]; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 15; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: object[] = []; //勾选的数据的集合
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };
  private iframe:any = null  //装载pdf的iframe对象
  private breadcrumbName = '' //当前打印按钮名称
  created() {
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  beforeDestroy() {
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src); 
    }
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    let params = {
      current: this.pageNo,
      size: this.pageSize
    };
    try {
      let res = await getEmployInfo(params);
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.pageNo = res.data.current;
      this.pageSize = res.data.size;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error.mesg || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    this.chooseIdArray = [...v];
    // this.chooseIdArray = v.map((item: any) => {
    //   return item.id;
    // });
  }
  //返回列表页
  private goBack(){
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src); 
    }

    this.$refs['iframeContainer'].removeChild(this.iframe);
    this.iframe = null
  }

//预览pdf
 private previewPDF(res){
    //创建一个iframe
    this.iframe = document.createElement("iframe");
    this.iframe.setAttribute("frameborder", 0);
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.$refs['iframeContainer'].appendChild(this.iframe);
    this.iframe.src = window.URL.createObjectURL(res)
  }
  //清空表格选中
  private clearSelection(){
    this.$refs['table'].clearSelection()
  }
  /**
   * “打印聘书”处理
   * @param {number} type 1为聘书，2为优秀证书
   */
  private async printHandle(type) {
    try{
        if (this.chooseIdArray.length <= 0) {
          this.$message.warning("请勾选一条记录！");
          return false;
        }
        if(this.chooseIdArray.length > 1) {
          this.$message.error("最多勾选一条记录！");
          return false;
        }
        let params = {
          employProjectId:  this.chooseIdArray[0][`projectId`], // 项目id
          employSourceId: this.chooseIdArray[0][`sourceId`], //科目id
          employSubjectId: this.chooseIdArray[0][`subjectId`], //科目id
          employTeacherId:  this.chooseIdArray[0][`teacherId`] // 教师id
        }
      let url = type == 1 ? downloadContract : downloadCertificate;
      this.breadcrumbName = type == 1 ? '打印聘书' : '打印优秀证书'
      let res = await url(params);
      this.clearSelection() //清空选择
      this.previewPDF(res) //预览pdf
    }
    catch(error){
     this.clearSelection() //清空选择
        // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
